// LICENSE_CODE ZON
'use strict'; /*jslint ts:true, react:true*/
import React, {useContext, useEffect} from 'react';
import cn from 'classnames';
import {Settings_context} from '../settings_ctx';
import {Button} from '../../../shared/button';
import Icon_alert from '../img/svg/icon/alert_icon.svg';
import {vpn_perr} from './perr';
import styles from './country_unavailable.module.less';

interface i_props {
    country?: string;
    url?: string;
    product?: 'vpn'|'hola';
}

const products = {
    vpn: {title: 'VPN Not available!',
        perr_id: 'www_full_vpn_unavailable_country_show'},
    hola: {title: 'Hola is Not available!',
        perr_id: 'www_site_unavailable_country_show'},
};

export const Country_unavailable = ({country, url, product='vpn'}: i_props)=>{
    const {theme} = useContext(Settings_context);
    const {title, perr_id} = products[product];
    useEffect(()=>{
        vpn_perr(perr_id, {country, path: window.location.pathname});
    }, []);
    return <div className={cn(theme.root, styles.root)}>
      <Icon_alert width={40} height={40}/>
      <p className={cn(styles.title, theme.p1, theme.bold, theme.color_n700)}>
        {title}</p>
      <p className={cn(styles.text, theme.p2, theme.reg, theme.color_n600)}>
        Unfortunately, Hola is not available in your country or region.
        We're sorry for the inconvenience.</p>
      {!!url && <Button round arrow color="white" to={url}
        caption="Read more" cls={styles.button}/>}
    </div>;
};
